import { motion } from "framer-motion";
import { ShieldAlert } from "lucide-react";
import { FLEET } from "../data";
import { useLang } from "../LanguageContext";

export const Fleet = () => {
  const { t } = useLang();
  return (
    <section id="flota" className="bg-[#0F0F0F] py-20 sm:py-28 border-y border-white/10">
      <div className="max-w-7xl mx-auto px-5 sm:px-8">
        <div className="max-w-2xl mb-12">
          <p className="font-body text-xs font-bold uppercase tracking-[0.22em] text-[#E02020] mb-4">{t.fleet.overline}</p>
          <h2 className="font-display text-3xl sm:text-4xl lg:text-5xl font-bold tracking-tight text-white">
            {t.fleet.title}
          </h2>
        </div>

        <div className="flex md:grid md:grid-cols-3 gap-5 overflow-x-auto md:overflow-visible snap-x snap-mandatory hide-scrollbar -mx-5 px-5 md:mx-0 md:px-0">
          {FLEET.map((card, i) => (
            <motion.article
              key={card.id}
              initial={{ opacity: 0, y: 24 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true, margin: "-60px" }}
              transition={{ duration: 0.5, delay: i * 0.1, ease: "easeOut" }}
              data-testid={`fleet-card-${card.id}`}
              className="group min-w-[82%] sm:min-w-[60%] md:min-w-0 snap-start bg-[#1A1A1A] border border-[#262626] rounded-sm overflow-hidden flex flex-col"
            >
              <div className="aspect-[4/3] overflow-hidden bg-black">
                <img
                  src={card.image}
                  alt={card.models}
                  loading="lazy"
                  className="w-full h-full object-cover transition-transform duration-500 group-hover:scale-105"
                />
              </div>
              <div className="p-6 flex flex-col flex-1">
                <span className="self-start text-[11px] font-bold uppercase tracking-[0.15em] text-[#E02020] border border-[#E02020]/40 px-2.5 py-1 rounded-sm mb-3">
                  {t.fleet.cards[i].badge}
                </span>
                <h3 className="font-display text-xl font-semibold text-white">{card.models}</h3>
                <p className="mt-3 text-sm text-[#A3A3A3] leading-relaxed">{t.fleet.cards[i].desc}</p>
              </div>
            </motion.article>
          ))}
        </div>

        <motion.div
          initial={{ opacity: 0, y: 20 }}
          whileInView={{ opacity: 1, y: 0 }}
          viewport={{ once: true }}
          transition={{ duration: 0.5 }}
          data-testid="safety-callout"
          className="mt-8 flex items-start gap-4 bg-gradient-to-r from-[#E02020]/15 to-transparent border border-[#E02020]/30 rounded-sm p-6"
        >
          <ShieldAlert className="text-[#E02020] shrink-0 mt-0.5" size={26} />
          <p className="text-sm sm:text-base text-white/90 leading-relaxed">
            <span className="font-semibold">{t.fleet.safetyBold}</span>{t.fleet.safety}
          </p>
        </motion.div>
      </div>
    </section>
  );
};
